import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-contracts',
  templateUrl: './all-contracts.component.html',
  styleUrls: ['./all-contracts.component.css']
})
export class AllContractsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
